var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weixinband"},[_c('p',[_vm._v("绑定微信")]),_c('wechatView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }